import { Component, Input } from "@angular/core";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ViewDataComponent } from "../modals/view-data/view-data.component";
import { EditDataComponent } from "../modals/edit-data/edit-data.component";
import { Form } from "../../../../api/models/form";
import {
  Filing,
  FormFilter,
  FormState,
  FormType,
} from "../../../../api/models";
import { FilingService } from "../../../../api/services/filing.service";
import { ConfirmationService, MessageService } from "primeng/api";
import UNPROCESSED = FormState.UNPROCESSED;
import TBD = FormState.TBD;

import { DiscardConfirmationComponent } from "../modals/discard-confirmation/discard-confirmation.component";
import { PreviousFilingIdService } from "src/core/services/shared/filingId.service";
import { NgForm } from "@angular/forms";
import { handlePasteWithoutLeadingSpaces, preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-llm",
  templateUrl: "./llm.component.html",
  styleUrl: "./llm.component.css",
  standalone: false,
})
export class LlmComponent {
  filings: Form[] = [];

  // selectedProducts: any[] = []; // To store selected rows
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  ref!: DynamicDialogRef;
  selectedPlans: any[] = [];
  formRows: any[] = [];
  formTypes = FormType.values();
  selectedFormType: FormType | undefined;
  @Input() filingIdInput?: number;
  @Input() filingStateInput?: string;
  issuerNameInput?: string;
  followUpFilter: string = "all";
  followUpOptions: string[] = ["all", "TBD"];

  thisUser = "";
  rangeDates: Date[] | undefined;
  startDateInput?: Date | string;
  endDateInput?: Date | string;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };

  constructor(
    private _filingService: FilingService,
    private _messageService: MessageService,
    public dialogService: DialogService,
    public _confirmationService: ConfirmationService,
    private previousFilingIdService: PreviousFilingIdService
  ) {
    const email = localStorage.getItem("email");
    if (email) this.thisUser = email;
  }

  ngOnInit(): void {
    this.setFollowUpFilter();
  }
  private setFollowUpFilter(): void {
    if (this.filingStateInput === "TBD") {
      this.followUpFilter = "TBD";
      this.onSearch();
    } else if (this.filingStateInput === "UNPROCESSED") {
      this.followUpFilter = "all";
      this.onSearch();
    }
  }
  get formState(): FormState {
    return this.followUpFilter === "TBD" ? TBD : UNPROCESSED;
  }
  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  isLastPage(): boolean {
    return this.filings ? this.first + this.rows >= this.filings.length : true;
  }

  isFirstPage(): boolean {
    return this.filings ? this.first === 0 : true;
  }

  openViewModal(form: Form, event?: Event, filing?: Filing) {
    if (filing && filing.filingId !== undefined) {
      this.previousFilingIdService.setPreviousFiling(
        filing.filingId.toString(),
        "UNPROCESSED"
      );
    }
    if (event) event.preventDefault();
    this.showViewDialog(form, filing);
  }

  openEditModal(form: Form, filing: Filing) {
    this.ref = this.dialogService.open(EditDataComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,

      style: { width: "80vw", height: "100vh", top: "0", left: "0" },
      contentStyle: { overflow: "auto", height: "calc(100vh - 5rem)" },
      baseZIndex: 10000,

      data: {
        filing: filing,
        form: form,
        selectedPlans: this.selectedPlans,
      },
    });

    this.ref.onClose.subscribe((data: any) => {
      let updatedFiling = filing;
      let updatedForm = form;

      if (data) {
        updatedFiling = data.filing || filing;
        updatedForm = data.form || form;

        const updatedPlans = data.filing?.tradingPlans || [];
        const originalPlans = filing.tradingPlans || [];

        // Merge updated and original plans
        const mergedTradingPlans = [
          ...originalPlans.map((originalPlan: any) => {
            const updatedPlan = updatedPlans.find(
              (u: any) => u.tradingPlanId === originalPlan.tradingPlanId
            );
            return updatedPlan ? updatedPlan : originalPlan;
          }),
          ...updatedPlans.filter(
            (updatedPlan: any) =>
              !originalPlans.some(
                (originalPlan: any) =>
                  originalPlan.tradingPlanId === updatedPlan.tradingPlanId
              )
          ),
        ];

        updatedFiling = {
          ...filing,
          ...data.filing,
          tradingPlans: mergedTradingPlans,
        };
      } else {
        this.unlockFileAndRefresh(filing.filingId as any);
      }

      this.openViewModal(updatedForm, undefined, updatedFiling);
    });
  }
  onDateChange() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      const formatDate = (date: Date) => date.toLocaleDateString("en-CA"); // yyyy-mm-dd (local)

      this.startDateInput = formatDate(this.rangeDates[0]);
      this.endDateInput = formatDate(this.rangeDates[1]);

      this.onSearch();
    } else {
      this.startDateInput = undefined;
      this.endDateInput = undefined;
      this.onSearch();
    }
  }
onSearch(form?: NgForm) {
  if (form && form.invalid) {
    form.control.markAllAsTouched();
    return;
  }

  this.first = 0;
  this.paginator.pageNumber = 1;
  this.getFilingWithFilingFilter();
}

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getFilingWithFilingFilter();
  }

  getFilingWithFilingFilter() {
        const cleanedIssuerName =
    typeof this.issuerNameInput === 'string'
      ? this.issuerNameInput.trim()
      : this.issuerNameInput;
  
 
    const params: FormFilter = {
      formState: this.followUpFilter === "TBD" ? TBD : UNPROCESSED,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      formType: this.selectedFormType,
      filingId: this.filingIdInput,
      issuerName: cleanedIssuerName,
      startDate:
        this.startDateInput instanceof Date
          ? this.startDateInput.toISOString()
          : this.startDateInput,
      endDate:
        this.endDateInput instanceof Date
          ? this.endDateInput.toISOString()
          : this.endDateInput,
    };
    this.isLoading = true;
    this._filingService.getFilings(params).subscribe({
      next: (value) => {
        this.filings = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.filings.length > 0 ? this.filings[0].totalCount! : 0;
        this.isLoading = false;
      },
    });
  }

  addProtocol(url: string): string {
    if (!/^https?:\/\//i.test(url)) {
      return "https://" + url;
    }
    return url;
  }

  lockFile(filing: any) {
    let result = true;
    if (!filing) return;
    this._filingService.lockFiling({ filingId: filing.filingId }).subscribe({
      next: (value) => {
        result = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        if (result) this.getFilingWithFilingFilter();
        this._messageService.add({
          summary: "The file is locked successfully.",
          severity: "success",
        });
      },
    });
  }

  lockFileByForce(filing: any) {
    this._filingService
      .lockFiling({ filingId: filing.filingId, isForceLock: true })
      .subscribe({
        next: (value) => {
          if (value) this.getFilingWithFilingFilter();
        },
        error: (err) => {
          this.isLoading = false;
          this._messageService.add({
            summary: err.error.message,
            severity: "error",
          });
        },
        complete: () => {},
      });
  }

  confirmUnlock(filing: any) {
    if (filing.lockedBy == this.thisUser) {
      this._confirmationService.confirm({
        message: `This filing is locked by you. Do you want to unlock it?`,
        header: "Unlock Confirmation",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Yes",
        rejectLabel: "No",
        accept: () => {
          this.unlockFile(filing);
        },
      });
      return;
    }
    this._confirmationService.confirm({
      message: `This filing is locked by ${filing.lockedBy}. Do you want to force unlock and edit it?`,
      header: "Unlock Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Yes",
      rejectLabel: "No",
      accept: () => {
        this.lockFileByForce(filing);
      },
    });
  }

  unlockFile(filing: any) {
    this.isLoading = true;
    this._filingService.unlockFiling(filing.filingId).subscribe({
      next: (value) => {
        if (value)
          this._messageService.add({
            summary: "The file is unlocked successfully",
            severity: "success", // or "error" if appropriate
          });
      },
      error: (err) => {
        if (err.status === 409) {
          // Handle 409 Conflict specifically
          this._messageService.add({
            summary: "You are not allowed to unlock this file",
            severity: "warn", // or "error" if appropriate
          });
        } else {
          // Handle other errors
          this._messageService.add({
            summary: "You are not allowed to unlock this file",
            severity: "error",
          });
        }
      },
      complete: () => {
        this.getFilingWithFilingFilter();
      },
    });
  }

  private lockAndOpenFile(filingId: number, form: Form, filing?: Filing) {
    let result;
    this._filingService.lockFiling({ filingId: filingId }).subscribe({
      next: (value) => {
        result = value;
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "File was unable to be locked.",
        });
      },
      complete: () => {
        if (filing) {
          this.openRefDialog(form, filing);
          return;
        }
        this._filingService.getFilingByFilingId(filingId).subscribe({
          next: (value) => {
            this.openRefDialog(form, value);
          },
        });
      },
    });
  }

  private showViewDialog(form: Form, filing?: Filing) {
    if (!form?.filingId) return;
    this.lockAndOpenFile(form.filingId, form, filing);
  }

  private openRefDialog(form: Form, filing: Filing) {
    this.ref = this.dialogService.open(ViewDataComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,

      showHeader: true,
      // Simulate maximized view
      style: {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        maxHeight: "100vh",
        padding: "0",
        margin: "0",
        borderRadius: "0",
      },
      // Adjust internal scrolling content
      contentStyle: {
        height: "calc(100vh - 4rem)",
        overflow: "auto",
      },
      baseZIndex: 10000,

      data: {
        form: form,
        filing: filing,
      },
    });

    this.ref.onClose.subscribe({
      next: (data) => {
        if (!data) {
          this.unlockFileAndRefresh(filing.filingId as any);
          return;
        }
        if (data?.refresh) {
          this.unlockFileAndRefresh(filing.filingId as any);
        } else if (data) {
          this.selectedPlans = data;
          this.openEditModal(form, filing);
        }
      },
    });
  }

  unlockFileAndRefresh(filingId: number) {
    this.isLoading = true;
    this._filingService.unlockFiling(filingId).subscribe({
      next: (value) => {},
      error: (err) => {
        if (err.status === 409) {
          // Handle 409 Conflict specifically
          this._messageService.add({
            summary: "You are not allowed to unlock this file.",
            severity: "warn", // or "error" if appropriate
          });
        } else {
          // Handle other errors
          this._messageService.add({
            summary: "You are not allowed to unlock this file",
            severity: "error",
          });
        }
      },
      complete: () => {
        this.getFilingWithFilingFilter();
      },
    });
  }
   preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }
  
  onPaste(
    event: ClipboardEvent,
    field: "issuerNameInput" | "filingIdInput"
  ): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
  
      if (field === "issuerNameInput") {
        this.issuerNameInput = newValue.trim() || undefined;
        return;
      }
  
      if (field === "filingIdInput") {
        const num = Number(newValue.trim());
        this.filingIdInput = Number.isNaN(num) ? undefined : num;
      }
  
    });
  }
}
